module.exports = __webpack_public_path__ + "media/flags/de-cc670a05.png";